import { Box, ShimmerText, VStack } from '@betterment/samba-react';

const ShimmerItem = () => (
  <VStack css={{ gap: 'space.200' }}>
    <ShimmerText textStyle="text25" css={{ width: '120px', height: '12px' }} />
    <ShimmerText textStyle="text100" css={{ width: '300px', height: '12px' }} />
  </VStack>
);

export const LoadingResourcesCard = () => (
  <Box css={{ display: 'grid', gridTemplateColumns: { base: '1fr', lg: '1fr 1fr' }, gap: 'space.300' }}>
    <ShimmerItem />
    <ShimmerItem />
    <ShimmerItem />
    <ShimmerItem />
  </Box>
);
